(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1-video-2-image-product-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('arzeni-product-showcase')) {
    customElements.define(
      'arzeni-product-showcase',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          const form = this.querySelector('.aps-form');
          if (!form) return;

          const price = this.querySelector('[data-current-price]');
          const buy = this.querySelector('.aps-buy');
          const error = this.querySelector('.aps-error');

          form.addEventListener('change', (event) => {
            if (event.target.matches('input[name="id"]')) {
              price.innerHTML = event.target.dataset.price;
              error.hidden = true;
            }
          });

          form.addEventListener('submit', async (event) => {
            event.preventDefault();
            if (buy.disabled) return;

            const selected = form.querySelector(
              'input[name="id"]:checked:not(:disabled)'
            );

            if (!selected) return;

            buy.disabled = true;
            buy.setAttribute('aria-busy', 'true');
            error.hidden = true;

            const root = window.Shopify?.routes?.root || '/';

            try {
              const response = await fetch(root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: selected.value,
                      quantity: 1
                    }
                  ]
                })
              });

              const result = await response.json();

              if (!response.ok) {
                throw new Error(
                  result.description || this.dataset.error
                );
              }

              window.location.assign(root + 'checkout');
            } catch (failure) {
              error.textContent =
                failure.message || this.dataset.error;

              error.hidden = false;
              buy.disabled = false;
              buy.removeAttribute('aria-busy');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["4-image-grid"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('arzeni-royal-grid')) {
  customElements.define('arzeni-royal-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.handleClick) return;
      this.handleClick = async (event) => {
        const button = event.target.closest('button[data-variant-id]');
        if (!button || !this.contains(button) || button.disabled) return;
        const error = button.closest('article').querySelector('.arzeni-grid-error');
        error.hidden = true;
        const originalText = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = this.dataset.addingText;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: button.dataset.variantId, quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(button.dataset.productUrl);
        } catch (failure) {
          error.textContent = this.dataset.errorText;
          error.hidden = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = originalText;
        }
      };
      this.addEventListener('click', this.handleClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.handleClick = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arzeni-panels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('arzeni-royal-panels')) {
    customElements.define('arzeni-royal-panels', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.arp__track');
        this.panels = Array.from(this.querySelectorAll('.arp__panel'));
        this.dots = Array.from(this.querySelectorAll('[data-go]'));
        this.mobile = window.matchMedia('(max-width: 989px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.editorPanel = null;
        this.frame = null;
        this.resizeFrame = null;
        this.panels.forEach(panel => {
          panel.addEventListener('pointerenter', event => {
            if (!this.mobile.matches && event.pointerType === 'mouse' && !this.editorPanel) this.expand(panel);
          }, options);
        });
        this.addEventListener('pointerleave', () => {
          if (!this.editorPanel) this.expand(this.panels.find(panel => panel.contains(document.activeElement)));
        }, options);
        this.addEventListener('focusin', event => {
          if (!this.mobile.matches) this.expand(event.target.closest('.arp__panel'));
        }, options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (this.isConnected && !this.editorPanel) this.expand(this.panels.find(panel => panel.contains(document.activeElement)));
          });
        }, options);
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-go], button[data-step]');
          if (!button || !this.contains(button)) return;
          const index = button.hasAttribute('data-go') ? Number(button.dataset.go) : this.index + Number(button.dataset.step);
          this.go(index);
        }, options);
        this.track.addEventListener('keydown', event => {
          if (!this.mobile.matches || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          let index = this.index;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.panels.length - 1;
          if (event.key === 'ArrowRight') index += rtl ? -1 : 1;
          if (event.key === 'ArrowLeft') index += rtl ? 1 : -1;
          if (document.activeElement !== this.track) this.track.focus({ preventScroll: true });
          this.go(index);
        }, options);
        this.track.addEventListener('scroll', () => {
          if (!this.mobile.matches || this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const trackRect = this.track.getBoundingClientRect();
            const center = trackRect.left + trackRect.width / 2;
            let nearest = 0;
            let distance = Infinity;
            this.panels.forEach((panel, index) => {
              const rect = panel.getBoundingClientRect();
              const gap = Math.abs(rect.left + rect.width / 2 - center);
              if (gap < distance) { nearest = index; distance = gap; }
            });
            this.update(nearest);
          });
        }, { ...options, passive: true });
        const resize = () => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            this.style.setProperty('--arp-viewport-width', `${document.documentElement.clientWidth}px`);
            this.expand(this.editorPanel);
            this.update(this.index);
            if (this.mobile.matches) this.go(this.index, false);
            else this.track.scrollLeft = 0;
          });
        };
        window.addEventListener('resize', resize, { ...options, passive: true });
        this.mobile.addEventListener('change', resize, options);
        document.addEventListener('shopify:block:select', event => {
          const panel = this.panels.find(item => item.dataset.blockId === event.detail?.blockId);
          if (!panel) return;
          this.editorPanel = panel;
          if (this.mobile.matches) this.go(this.panels.indexOf(panel), false);
          else this.expand(panel);
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (this.editorPanel?.dataset.blockId !== event.detail?.blockId) return;
          this.editorPanel = null;
          this.expand(null);
        }, options);
        this.classList.add('is-ready');
        this.update(0);
        resize();
      }
      expand(active) {
        this.panels.forEach(panel => panel.classList.toggle('is-active', !this.mobile.matches && panel === active));
      }
      go(index, animate = true) {
        if (!this.mobile.matches || !this.panels.length) return;
        index = Math.max(0, Math.min(index, this.panels.length - 1));
        this.update(index);
        const left = this.track.scrollLeft + this.panels[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollTo({ left, behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'instant' });
      }
      update(index) {
        this.index = index;
        this.panels.forEach((panel, position) => {
          const hidden = this.mobile.matches && position !== index;
          if (hidden && panel.contains(document.activeElement)) this.track.focus({ preventScroll: true });
          panel.inert = hidden;
          if (hidden) panel.setAttribute('aria-hidden', 'true');
          else panel.removeAttribute('aria-hidden');
        });
        this.dots.forEach((dot, position) => dot.setAttribute('aria-pressed', String(position === index)));
        const previous = this.querySelector('[data-step="-1"]');
        const next = this.querySelector('[data-step="1"]');
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === this.panels.length - 1;
        const status = this.querySelector('[data-status]');
        const announcement = this.panels[index]?.dataset.announcement || '';
        if (status && this.mobile.matches && status.textContent !== announcement) status.textContent = announcement;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.resizeFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    



  class StickyHeader extends HTMLElement {



    constructor() {



      super();



    }



    connectedCallback() {



      this.header = document.querySelector('.section-header');



      this.headerIsAlwaysSticky =



        this.getAttribute('data-sticky-type') === 'always' ||



        this.getAttribute('data-sticky-type') === 'reduce-logo-size';



      this.headerBounds = {};



      this.setHeaderHeight();



      window.matchMedia('(max-width: 1279px)').addEventListener('change', this.setHeaderHeight.bind(this));



      if (this.headerIsAlwaysSticky) {



        this.header.classList.add('shopify-section-header-sticky');



      }



      this.currentScrollTop = 0;



      this.preventReveal = false;



      this.predictiveSearch = this.querySelector('predictive-search');



      this.onScrollHandler = this.onScroll.bind(this);



      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);



      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);



      window.addEventListener('scroll', this.onScrollHandler, false);



      this.createObserver();



    }



    setHeaderHeight() {



      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);



    }



    disconnectedCallback() {



      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);



      window.removeEventListener('scroll', this.onScrollHandler);



    }



    createObserver() {



      let observer = new IntersectionObserver((entries, observer) => {



        this.headerBounds = entries[0].intersectionRect;



        observer.disconnect();



      });



      observer.observe(this.header);



    }



    onScroll() {



      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;



      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;



      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {



        this.header.classList.add('scrolled-past-header');



        if (this.preventHide) return;



        requestAnimationFrame(this.hide.bind(this));



      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {



        this.header.classList.add('scrolled-past-header');



        if (!this.preventReveal) {



          requestAnimationFrame(this.reveal.bind(this));



        } else {



          window.clearTimeout(this.isScrolling);



          this.isScrolling = setTimeout(() => {



            this.preventReveal = false;



          }, 66);



          requestAnimationFrame(this.hide.bind(this));



        }



      } else if (scrollTop <= this.headerBounds.top) {



        this.header.classList.remove('scrolled-past-header');



        requestAnimationFrame(this.reset.bind(this));



      }



      this.currentScrollTop = scrollTop;



    }



    hide() {



      if (this.headerIsAlwaysSticky) return;



      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');



      this.closeMenuDisclosure();



      this.closeSearchModal();



    }



    reveal() {



      if (this.headerIsAlwaysSticky) return;



      this.header.classList.add('shopify-section-header-sticky', 'animate');



      this.header.classList.remove('shopify-section-header-hidden');



    }



    reset() {



      if (this.headerIsAlwaysSticky) return;



      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');



    }



    closeMenuDisclosure() {



      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');



      this.disclosures.forEach((disclosure) => disclosure.close());



    }



    closeSearchModal() {



      this.searchModal = this.searchModal || this.header.querySelector('details-modal');



      this.searchModal.close(false);



    }



  }



  customElements.define('sticky-header', StickyHeader);




  } catch(e) { console.error(e); }
})();
})();
